import React from 'react';
import { useTranslation } from 'react-i18next';

export interface Props {
  /** obiekt z danymi do wyśweitlenia w formie klucz-wartość */
  data: SingleObjectDataStructure;
}

/**
 *  Komponent listy szczegółów karty przedmiotu (wypełnienie lewej ramki karty przedmiotu)
 *
 */
export const SubjectCardDetailsList: React.FunctionComponent<Props> = (props: Props): React.ReactElement => {
  const { t } = useTranslation();
  const { data } = props;
  return (
    <>
      <div>
        <h4>{t('PRZYDZIAL_PRZEDMIOTNAZWA')}</h4>
        <strong>{data.przedmiotNazwa}</strong>
      </div>
      <div>
        <h4>{t('PRZYDZIAL_PRZEDMIOTKOD')}</h4>
        <strong>{data.przedmiotKod}</strong>
      </div>
      <div>
        <h4>{t('KIERUNEK_NAZWA')}</h4>
        <strong>{data.kierunekNazwa}</strong>
      </div>
      <div>
        <h4>{t('POZIOM_STUDIOW')}</h4>
        <strong>{data.poziomStudiow}</strong>
      </div>
      <div>
        <h4>{t('DATA_AKTUALIZACJI')}</h4>
        <strong>{data.dataAktualizacji}</strong>
      </div>
    </>
  );
};

export default SubjectCardDetailsList;
